/**
 * @generated SignedSource<<b71ead517b6dadf7bb782b34946a8480>>
 * @relayHash 3e105ba686a3c7e413dfa0d3b76a857f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e9f03be7c278eb49be8080be8946d8663b0cffe9208a3205ce9ef65215ab6565

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOBoardPerformanceSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOBoardPerformanceStatus = "FAST" | "MODERATE" | "SLOW" | "%future added value";
export type JiraCFOFilterOperator = "EQUALS" | "IN" | "%future added value";
export type JiraCFOFilterInput = {
  boardFilter?: JiraCFOBoardFilterInput | null | undefined;
  dimensionFilter?: JiraCFODimensionFilterInput | null | undefined;
};
export type JiraCFOBoardFilterInput = {
  creatorAccountId?: ReadonlyArray<string> | null | undefined;
  keyword?: string | null | undefined;
  performanceStatus?: ReadonlyArray<JiraCFOBoardPerformanceStatus | null | undefined> | null | undefined;
  sortInput?: ReadonlyArray<JiraCFOBoardPerformanceSortInput | null | undefined> | null | undefined;
};
export type JiraCFOBoardPerformanceSortInput = {
  key?: string | null | undefined;
  order?: JiraCFOBoardPerformanceSortOrder | null | undefined;
};
export type JiraCFODimensionFilterInput = {
  name: string;
  operator: JiraCFOFilterOperator;
  values: ReadonlyArray<string>;
};
export type BoardPerformanceTabsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  endDate: AGG$DateTime;
  filters?: ReadonlyArray<JiraCFOFilterInput> | null | undefined;
  startDate: AGG$DateTime;
};
export type BoardPerformanceTabsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardPerformanceTabSummary" | "BoardPerformanceTabTable">;
};
export type BoardPerformanceTabsQuery = {
  response: BoardPerformanceTabsQuery$data;
  variables: BoardPerformanceTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v7 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Literal",
  "name": "dimensions",
  "value": [
    {
      "name": "jira_board_id"
    }
  ]
},
v11 = {
  "type": "COUNT"
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v14 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabSummary"
      },
      {
        "args": [
          (v9/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "boardPerformanceSummary",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": {
                      "type": "AVG"
                    },
                    "alias": "loadTime",
                    "name": "ttvc90",
                    "summarize": true
                  },
                  {
                    "aggregation": (v11/*: any*/),
                    "alias": "views",
                    "name": "*",
                    "summarize": true
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moderateBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardThreshold"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardThreshold"
                          }
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "after",
                    "value": ""
                  },
                  (v13/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": "data(after:\"\",first:25)"
              }
            ]
          },
          {
            "alias": "boardPerformanceTableValues",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v11/*: any*/),
                    "alias": "views",
                    "name": "*"
                  },
                  {
                    "aggregation": {
                      "type": "PERCENTILE",
                      "value": 0.5
                    },
                    "alias": "loadTime",
                    "name": "ttvc90"
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "args": [
                  (v9/*: any*/),
                  (v13/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "boardCreator",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "perfStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "projectKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "optimizationSuggestion"
                              }
                            ],
                            "type": "JiraCFOBoardPerformanceDataRow"
                          }
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/),
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e9f03be7c278eb49be8080be8946d8663b0cffe9208a3205ce9ef65215ab6565",
    "metadata": {},
    "name": "BoardPerformanceTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "306a79f31bf6a2bceda3f37cbfbdfbad";

export default node;
